import React from "react";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";
import { checklist_options } from "./constants/checklist";
import { user_access } from "../../Constants/selections";

class Checklist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: true,
      page: "all",
      brand_data: null,
      checklist: [],
      currentTab: user_access[0],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      const { currentTab } = this.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        if (!brand_data) return;
        this.setState({
          brand_data,
          brandID: brand,
          logo: brand_data.logo,
          icon: brand_data.icon,
          loading: false,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
          territory: brand_data.territory || "UK",
          menus: brand_data.menus,
          lightUserUpgrade: brand_data.menus
            ? brand_data.menus.lightUserUpgrade === undefined
              ? true
              : brand_data.menus.lightUserUpgrade
            : true,
        });

        this.loadChecklist(brand_data.name, currentTab.value);
      });
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.currentTab.label !== this.state.currentTab.label) {
      const { brand_name, currentTab } = this.state;
      this.loadChecklist(brand_name, currentTab.value);
    }
  }

  populateEmptyChecklistFields(checklistResponse, checklist_options) {
    let checklist = [];
    const checklistOrder = checklistResponse.reduce((accumulator, item) => {
      accumulator[item.order] = item.value;
      return accumulator;
    }, {});

    for (let i = 0; i < checklist_options.length; i++) {
      checklist.push({
        order: i,
        value: checklistOrder[i]
          ? checklistOrder[i]
          : { value: null, label: "none" },
      });
    }
    return checklist;
  }

  loadChecklist = async (brand_name, category) => {
    this.setState({ loading: true });
    try {
      const res = await Firebase.getChecklist(brand_name, category);
      const checklist = this.populateEmptyChecklistFields(
        res,
        checklist_options
      );
      this.setState({ checklist });
    } catch (e) {
      console.log(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChangeCheckitem = (number) => (value) => {
    const { checklist, brand_name, currentTab } = this.state;
    const prevValue = checklist.find((option) => option.order === number);
    // don't do anything if label doesn't change
    if (prevValue.value.label === value.label) return;

    if (prevValue.value === null && value.value !== null) {
      Firebase.addToChecklist(
        { value: value, order: number },
        brand_name,
        currentTab.value
      );
      // update state to reflect new added checklist item
      const updatedChecklist = checklist.map((option) =>
        option.order === number ? { order: number, value: value } : option
      );
      this.setState({ checklist: updatedChecklist });
    } else if (prevValue.value !== null && value.value === null) {
      Firebase.removeFromChecklist(brand_name, currentTab.value, number);

      // update state to reflect deleting checklist item
      const updatedChecklist = checklist.map((option) =>
        option.order === number
          ? { order: number, value: { value: null, label: "none" } }
          : option
      );
      this.setState({ checklist: updatedChecklist });
    } else {
      Firebase.updateChecklistEntry(
        brand_name,
        currentTab.value,
        number,
        value,
        number
      );
      // update state to reflect updating checklist item
      const updatedChecklist = checklist.map((option) =>
        option.order === number ? { order: number, value: value } : option
      );
      this.setState({ checklist: updatedChecklist });
    }
  };

  filterOptions = (option) => {
    const { checklist, currentTab } = this.state;

    const isEmailProspectAndEmailOption =
      currentTab.value === "Registered prospect email" && option === "email";
    if (isEmailProspectAndEmailOption) return false;

    const foundInChecklist = checklist.find(
      (item) => item && item.value.value === option
    );
    return !foundInChecklist;
  };

  renderContent = () => {
    const { checklist, currentTab, hex } = this.state;
    const { white } = this.state.brand_data;

    const newOptions = [
      { value: null, label: "none" },
      ...checklist_options.filter((option) => this.filterOptions(option.value)),
    ];
    return (
      <div
        className="incremental-tasks-container"
        style={{ marginTop: "15px" }}
      >
        <div className="tab-container mb-4">
          {user_access.map(({ label, value }, i) => (
            <button
              className="btn"
              style={{
                backgroundColor: currentTab.label === label ? hex : "white",
                color:
                  currentTab.label === label
                    ? white
                      ? "white"
                      : "black"
                    : "black",
              }}
              onClick={() =>
                this.setState({ currentTab: { label: label, value: value } })
              }
              key={`${label}${i}`}
            >
              {label}
            </button>
          ))}
        </div>
        {checklist
          .sort((a, b) => a.order - b.order)
          .map((checkitem, index) => (
            <div className="row-div mb-3" key={index}>
              <p>{index + 1}</p>
              &nbsp;&nbsp;&nbsp;
              <div style={{ width: 400 }}>
                <Select
                  value={checkitem.value}
                  onChange={this.handleChangeCheckitem(index)}
                  options={newOptions}
                  isSearchable={true}
                />
              </div>
            </div>
          ))}
      </div>
    );
  };

  render() {
    const {
      username,
      role,
      loading,
      logo,
      brand,
      brand_name,
      is_property_brand,
    } = this.state;

    return (
      <div id="page-container" className="token-earning-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && this.renderContent()}
        </main>
      </div>
    );
  }
}

export default Checklist;



// WEBPACK FOOTER //
// ./src/screens/Checklist/index.js